import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	disabledPopperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	disabledPopperText: {
		id: 'platform.ui.filter-refinement.assignee-picker.disabled.popper.text',
		defaultMessage:
			'You can’t filter by assignee with the current applied filters. Clear your filters and try again.',
		description:
			'Text shown in the popper that appears on hover of the assignee filter explaining why it is disabled',
	},
});
export default messages;
